import { useContext } from 'react';

import { StepperStateContext } from '../Context';

const useStepperState = () => {
  const stepperState = useContext(StepperStateContext);
  const { currentGate, gates } = stepperState;
  const currentGateId = [...gates.keys()][currentGate];

  return {
    ...stepperState,
    currentGateId,
  };
};

export default useStepperState;
